import { render, staticRenderFns } from "./QualifiedDividendIncomeTable.vue?vue&type=template&id=0ce934d5"
import script from "./QualifiedDividendIncomeTable.vue?vue&type=script&lang=js"
export * from "./QualifiedDividendIncomeTable.vue?vue&type=script&lang=js"
import style0 from "./QualifiedDividendIncomeTable.vue?vue&type=style&index=0&id=0ce934d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports